const getEventsStyles = disableEvents => ({
  pointerEvents: disableEvents ? 'none' : 'auto',
});

export const getSmartPageDefaultSiteTheme = (palette, disableEvents = false, isMobile = false) => {
  const eventsStyles = getEventsStyles(disableEvents);
  const defaultPageMarginLeft = isMobile ? 0 : 32;
  const defaultPageMarginRight = isMobile ? 0 : 32;

  return {
    components: {
      sectionTitle: {
        fontSize: 28,
        lineHeight: '40px',
        display: 'flex',
        justifyContent: 'center',
        margin: '0 0 28px 0',
        color: palette.primaryText,
      },
      section: {
        padding: '24px 0',
        marginLeft: defaultPageMarginLeft,
        marginRight: defaultPageMarginRight,
      },
      navLink: {
        color: palette.primaryText,
        ...eventsStyles,
      },
      defaultButton: {
        color: palette.secondaryText,
        background: 'transparent',
        border: `1px solid ${palette.secondaryText}`,
        width: '100%',
        height: 40,
        boxSizing: 'border-box',
        padding: '8px 16px',
        ...eventsStyles,
        '&:hover,  &:focus': {
          color: palette.secondaryText,
        },
      },
      primaryButton: {
        color: palette.buttonText,
        background: palette.buttonBackground,
        border: `1px solid ${palette.buttonBackground}`,
        width: '100%',
        height: 40,
        boxSizing: 'border-box',
        padding: '8px 16px',
        ...eventsStyles,
        '&:hover,  &:focus': {
          color: palette.buttonText,
        },
      },
      fixedMobileFooter: {
        height: 80,
      },
      link: {
        ...eventsStyles,
      },
      truncate: {
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    core: {
      palette,
      effects: {
        elevation: `0px -2px 10px 2px ${palette.elevation}`,
      },
    },
  };
};
